import { Injectable } from '@angular/core';
import { InspectorDialogComponent } from '../inspector-dialog/inspector-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class QBuiltInspectorDialogService {
  constructor(private dialog: MatDialog) {}

  openInspectorDialog(dialogType: number, dataList?: any[], userName?: string) {
    const widthMap: Record<number, string> = {
      //used to set custom width for each dialog type - can add more as needed
      3: '900px', // Add Observed Defect Dialog
    };

    const dialogRef = this.dialog.open(InspectorDialogComponent, {
      width: widthMap[dialogType] || 'auto',
      data: {
        dialogType: dialogType,
        dataList: dataList,
        userName: userName,
      },
    });

    return dialogRef;
  }
}
